import { render } from "./ProjectWrapper.vue?vue&type=template&id=c13e2990&scoped=true"
import script from "./ProjectWrapper.vue?vue&type=script&lang=js"
export * from "./ProjectWrapper.vue?vue&type=script&lang=js"

import "./ProjectWrapper.vue?vue&type=style&index=0&id=c13e2990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c13e2990"]])

export default __exports__